import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export default function ConfirmRegenerateDialog({ open, onOpenChange, existingDate, onConfirm }) {
  const dateStr = existingDate ? new Date(existingDate).toLocaleString("el-GR") : "";
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Υπάρχει ήδη έγγραφο AI αυτής της κατηγορίας</AlertDialogTitle>
          <AlertDialogDescription>
            Δημιουργήθηκε στις {dateStr}. Θέλετε να δημιουργήσετε ένα νέο, επιπλέον
            έγγραφο στην ίδια κατηγορία;
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Άκυρο</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Δημιουργία νέου</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
